import React from "react";

const BadgeLike = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    version="1.1"
    width={256}
    height={256}
    viewBox="0 0 256 256"
    xmlSpace="preserve"
    {...props}
  >
    <g
      style={{
        stroke: "none",
        strokeWidth: 0,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        strokeMiterlimit: 10,
        fill: "none",
        fillRule: "nonzero",
        opacity: 1,
      }}
      transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
    >
      <path
        d="M 80.386 77.959 L 69.929 55.535 c -6.21 6.668 -15.038 10.862 -24.833 10.922 l 10.708 22.965 c 0.135 0.289 0.399 0.497 0.712 0.559 c 0.066 0.014 0.131 0.02 0.196 0.02 c 0.249 0 0.49 -0.092 0.677 -0.263 l 9.477 -8.683 l 12.742 -1.678 c 0.316 -0.041 0.594 -0.231 0.748 -0.511 C 80.51 78.585 80.521 78.248 80.386 77.959 z"
        style={{
          stroke: "none",
          strokeWidth: 1,
          strokeDasharray: "none",
          strokeLinecap: "butt",
          strokeLinejoin: "miter",
          strokeMiterlimit: 10,
          fill: "rgb(160,77,215)",
          fillRule: "nonzero",
          opacity: 1,
        }}
        transform="matrix(1 0 0 1 0 0)"
        strokeLinecap="round"
      />
      <path
        d="M 44.886 66.462 c -9.8 0 -18.644 -4.145 -24.89 -10.767 L 9.614 77.959 c -0.135 0.29 -0.124 0.626 0.029 0.906 c 0.154 0.28 0.432 0.47 0.748 0.511 l 12.742 1.678 l 9.476 8.683 C 32.797 89.908 33.039 90 33.287 90 c 0.065 0 0.131 -0.006 0.196 -0.02 c 0.313 -0.062 0.577 -0.27 0.712 -0.559 l 10.707 -22.96 C 44.897 66.462 44.892 66.462 44.886 66.462 z"
        style={{
          stroke: "none",
          strokeWidth: 1,
          strokeDasharray: "none",
          strokeLinecap: "butt",
          strokeLinejoin: "miter",
          strokeMiterlimit: 10,
          fill: "rgb(160,77,215)",
          fillRule: "nonzero",
          opacity: 1,
        }}
        transform="matrix(1 0 0 1 0 0)"
        strokeLinecap="round"
      />
      <path
        d="M 44.886 0 c -12.75 0 -23.768 7.405 -28.995 18.148 c -2.032 4.224 -3.172 8.955 -3.172 13.947 c 0 8.262 3.123 15.805 8.247 21.521 l -0.064 0.137 c 5.9 6.571 14.458 10.706 23.984 10.706 c 17.8 0 32.229 -14.429 32.229 -32.229 S 62.686 0 44.886 0 z M 45 55.015 c -12.638 0 -22.921 -10.282 -22.921 -22.92 c 0 -0.553 0.449 -1.002 1.002 -1.002 s 1.002 0.449 1.002 1.002 c 0 11.533 9.383 20.916 20.917 20.916 c 0.553 0 1.002 0.448 1.002 1.002 S 45.553 55.015 45 55.015 z M 59.935 34.159 c -0.244 0.67 -0.733 1.204 -1.377 1.504 l -8.503 3.965 c -1.286 0.639 -2.962 1.132 -4.446 1.132 c -0.004 0 -0.009 0 -0.013 0 c -0.066 0.666 -0.492 1.293 -1.167 1.608 l -6.317 2.945 c -0.279 0.13 -0.579 0.197 -0.877 0.197 c -0.195 0 -0.39 -0.028 -0.578 -0.085 c -0.51 -0.154 -0.928 -0.51 -1.146 -0.979 l -5.52 -11.837 c -0.219 -0.468 -0.223 -1.018 -0.013 -1.507 c 0.196 -0.457 0.559 -0.828 1.021 -1.043 l 6.316 -2.946 c 0.752 -0.35 1.603 -0.214 2.163 0.28 c 0.913 -1.786 0.829 -5.97 -0.362 -8.878 l -0.287 -0.7 l 0.595 -0.466 c 1.152 -0.904 2.278 -1.2 3.349 -0.886 c 1.656 0.489 3.043 2.395 4.443 6.135 l 5.308 -2.486 c 0.644 -0.3 1.366 -0.332 2.038 -0.088 c 0.67 0.244 1.204 0.733 1.504 1.376 l 0.141 0.3 c 0.242 0.521 0.302 1.08 0.205 1.605 c 0.589 0.248 1.091 0.706 1.381 1.329 l 0.141 0.3 c 0.25 0.538 0.313 1.13 0.186 1.701 c 0.548 0.255 1.012 0.697 1.287 1.286 l 0.141 0.303 c 0.449 0.965 0.269 2.066 -0.373 2.835 c 0.216 0.214 0.397 0.47 0.533 0.761 l 0.141 0.3 C 60.147 32.765 60.179 33.489 59.935 34.159 z M 66.918 33.096 c -0.554 0 -1.002 -0.449 -1.002 -1.002 c 0 -11.534 -9.383 -20.917 -20.916 -20.917 c -0.553 0 -1.002 -0.449 -1.002 -1.002 S 44.447 9.173 45 9.173 c 12.638 0 22.92 10.282 22.92 22.921 C 67.92 32.648 67.472 33.096 66.918 33.096 z"
        style={{
          stroke: "none",
          strokeWidth: 1,
          strokeDasharray: "none",
          strokeLinecap: "butt",
          strokeLinejoin: "miter",
          strokeMiterlimit: 10,
          fill: "rgb(160,77,215)",
          fillRule: "nonzero",
          opacity: 1,
        }}
        transform="matrix(1 0 0 1 0 0)"
        strokeLinecap="round"
      />
      <path
        d="M 57.895 32.667 c -0.154 -0.332 -0.547 -0.475 -0.882 -0.323 c 0 0 0 0 0 0 l -1.504 0.702 c -0.137 0.064 -0.28 0.094 -0.422 0.094 c -0.377 0 -0.737 -0.213 -0.907 -0.577 c -0.233 -0.5 -0.017 -1.096 0.483 -1.329 l 1.504 -0.702 c 0 0 0.001 0 0.001 0 c 0 0 0 0 0 0 l 1.246 -0.58 c 0.331 -0.155 0.475 -0.551 0.32 -0.884 l -0.141 -0.302 c -0.15 -0.324 -0.556 -0.472 -0.882 -0.319 l -0.066 0.03 c 0 0 0 0 0 0 l -2.684 1.252 c -0.137 0.064 -0.28 0.094 -0.422 0.094 c -0.377 0 -0.737 -0.213 -0.907 -0.577 c -0.233 -0.5 -0.017 -1.096 0.483 -1.329 l 2.684 -1.252 c 0 0 0.001 0 0.001 0 c 0.159 -0.074 0.28 -0.208 0.341 -0.376 c 0.061 -0.168 0.054 -0.348 -0.021 -0.507 l -0.141 -0.3 c -0.154 -0.332 -0.548 -0.476 -0.884 -0.322 l -0.178 0.083 c -0.001 0 -0.001 0 -0.001 0 l -2.505 1.168 c -0.137 0.064 -0.28 0.094 -0.422 0.094 c -0.377 0 -0.737 -0.213 -0.907 -0.578 c -0.233 -0.5 -0.017 -1.095 0.483 -1.329 l 2.505 -1.168 c 0.332 -0.155 0.477 -0.551 0.322 -0.883 l -0.141 -0.3 c -0.074 -0.16 -0.208 -0.282 -0.376 -0.343 c -0.167 -0.061 -0.348 -0.055 -0.507 0.021 l -7.308 3.422 l -0.362 -1.051 c -1.55 -4.493 -2.755 -5.696 -3.494 -5.914 c -0.194 -0.058 -0.488 -0.089 -0.955 0.15 c 1.148 3.455 1.323 8.647 -0.719 10.77 l 2.409 5.165 c 0.233 0.501 0.017 1.096 -0.483 1.329 c -0.137 0.064 -0.281 0.094 -0.422 0.094 c -0.376 0 -0.737 -0.213 -0.907 -0.577 l -2.737 -5.869 c 0 0 0 -0.001 0 -0.001 l -0.236 -0.506 l -6.304 2.932 l 5.419 11.623 l 6.305 -2.932 l -1.38 -2.961 l 2.385 1 c 0.817 0.341 2.76 0.146 4.605 -0.771 l 8.526 -3.976 c 0.16 -0.074 0.281 -0.208 0.343 -0.376 c 0.061 -0.168 0.054 -0.348 -0.021 -0.507 L 57.895 32.667 z"
        style={{
          stroke: "none",
          strokeWidth: 1,
          strokeDasharray: "none",
          strokeLinecap: "butt",
          strokeLinejoin: "miter",
          strokeMiterlimit: 10,
          fill: "rgb(160,77,215)",
          fillRule: "nonzero",
          opacity: 1,
        }}
        transform="matrix(1 0 0 1 0 0)"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export default BadgeLike;